<!--
 * @Author: wangwang 2723008256@qq.com
 * @Date: 2023-08-11 09:06:57
 * @LastEditors: 番茄炒蛋蛋 wzh15802755802@163.com
 * @LastEditTime: 2025-02-28 13:27:48
 * @FilePath: \jzjypc4.2\src\components\yuyueBox\yuyuebox.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="yuyueevm">
      <el-dialog  :visible.sync="dialogVisible" :before-close="handleClose" width="400px" top="30vh">
        <div class="yyevmContent">
          <div class="top">
            <h3>打开微信扫一扫，添加好友</h3>
            <h3>可以领取更多优质资源哦~</h3>
          </div>
          <div class="signSuccessContent">
            
            <div class="pic">
              <img :src="hdkf_file_url" alt="" />
            </div>
            <p>成功添加后，下次进入不再提醒</p>
            <span @click="handleClose">已添加</span>
          </div>
        </div>
      </el-dialog>
    </div>
</template>

<script>
export default {
  props:['hdkf_file_url'],
  inject: ["reload"],
    data(){
        return{
          dialogVisible:true,
          dqkfevm:'',//公众号二维码
        }
    },
    methods:{
      handleClose(){
        this.$emit('qwtcClose')
      }
    },
}
</script>

<style lang="less" scoped>
    .yuyueevm {
    /deep/.el-dialog__header {
      padding: 0;
    }
    /deep/.el-dialog {
      margin-top: 13vh !important;
      border-radius: 20px;
    }
    /deep/.el-dialog__body {
      padding: 0;
      height: 450px;
    }
    /deep/.el-dialog__headerbtn .el-dialog__close{
        color: #FFF !important;
    }
    .yyevmContent {
      width: 400px;
      height: 500px;
      border-radius: 20px;
      .top {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-bottom: 20px;
        width: 400px;
        height: 120px;
        border-radius: 20px 20px 0px 0px;
        background-image: url('../../assets/img/activeNew/tcbg.png');
        background-size: 100%;
        background-repeat: no-repeat;
        img{
            width: 40px;
        }
        h3 {
        text-align: center;
        font-size: 18px;
        line-height: 30px;
        color: #fff;
      }
      }
      
      .signSuccessContent {
        text-align: center;
        overflow: hidden;
        .pic {
          margin: 0 auto;
          margin-bottom: 20px;
          width: 160px;
          height: 160px;
          border: 1px solid #dedede;
          img {
            width: 160px;
            height: 160px;
          }
        }
        p {
          text-align: center;
          width: 270px;
          margin: 0 auto;
          margin-bottom: 15px;
          text-align: center;
          font-size: 14px;
          color: #969799;
        }
        span{
            margin: 0 auto;
            margin-top: 10px;
            display: inline-block;
            text-align: center;
            width: 200px;
            height: 40px;
            line-height: 40px;
            color: #FFF;
            background: #1E60EB;
            border: 1px solid #DCDFE6;
            border-radius: 6px;
            cursor: pointer;
            user-select: none;
        }
        span:active{
            opacity: 0.8;
        }
      }
    }
  }
</style>